module.exports = __webpack_public_path__ + "img/ring_g_c_1_null@2x.e604bb66.png";